export default __webpack_public_path__ + "static/media/atam.b4e1fed1.png";